import React, { FC } from 'react';
import cx from 'classnames';
import styles from './index.module.scss';
import Skeleton from 'react-loading-skeleton';
import { TopLevelChannels } from '@/api/home';

// feed 流骨架屏
const SkeletonFeedContent: FC<{
  channel: TopLevelChannels,
}> = ({channel}) => {

  // 首页、广场feed流骨架屏
  const skeleton = (
    <div className={styles.skeletonFeedContent}>
      <Skeleton circle width={44} height={44} className={styles.avatar} />
      <div className={styles.feedContent}>
        <Skeleton width={120} height={16} className={cx(styles.text, styles.username)} />
        <Skeleton width={544} height={16} className={cx(styles.text, styles.subject)} />
        <Skeleton width={400} height={16} className={cx(styles.text, styles.summary)} />
        <Skeleton width={304} height={171} className={cx(styles.text, styles.content)} />
        <Skeleton width={176} height={16} className={cx(styles.text)} />
      </div>
    </div>
  )
  // 活动页feed流骨架屏
  const activitSkeleton = (
    <div className={styles.activitSkeleton}>
      <Skeleton width={280} height={148} style={{marginBottom: '10px'}} className={styles.radius6px} />
      <Skeleton width={100} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
      <Skeleton width={280} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
      <Skeleton width={280} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
      <Skeleton width={226} height={16} style={{marginBottom: '14px'}} className={styles.tag} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Skeleton borderRadius={6} width={100} height={16} className={styles.tag} />
        <Skeleton width={76} height={32} style={{borderRadius: '16px'}} />
      </div>
    </div>
  )
  if ([
    TopLevelChannels.home_page_recommended_channel,
    TopLevelChannels.home_page_plaza_channel,
    TopLevelChannels.equipment_circle_channel,
  ].includes(channel)) {
    return (
      <div className={styles.spinnerContainer}>
        {skeleton}
        {skeleton}
        {skeleton}
      </div>
    );
  }

  if (channel === TopLevelChannels.home_page_activity_channel) {
    return (
      <div className={styles.activitySkeleton}>
        {activitSkeleton}
        {activitSkeleton}
        {activitSkeleton}
        {activitSkeleton}
      </div>
    )
  }

  if (channel === TopLevelChannels.home_page_consult_channel) {
    return (
      <div className={styles.consultContent}>
        <div className={styles.consultSkeleton}>
          <div>
            <Skeleton width={444} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
            <Skeleton width={444} height={16} style={{marginBottom: '2px'}} className={styles.radius6px} />
            <Skeleton width={300} height={16} className={styles.radius6px} />
          </div>
          <Skeleton width={136} height={84} borderRadius={8} />
        </div>
        <div className={styles.consultSkeleton}>
          <div>
            <Skeleton width={444} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
            <Skeleton width={444} height={16} style={{marginBottom: '2px'}} className={styles.radius6px} />
            <Skeleton width={300} height={16} className={styles.radius6px} />
          </div>
          <Skeleton width={136} height={84} borderRadius={8} />
        </div>
        <div className={styles.consultSkeleton}>
          <div>
            <Skeleton width={444} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
            <Skeleton width={444} height={16} style={{marginBottom: '2px'}} className={styles.radius6px} />
            <Skeleton width={300} height={16} className={styles.radius6px} />
          </div>
          <Skeleton width={136} height={84} borderRadius={8} />
        </div>
        <div className={styles.consultSkeleton}>
          <div>
            <Skeleton width={444} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
            <Skeleton width={444} height={16} style={{marginBottom: '2px'}} className={styles.radius6px} />
            <Skeleton width={300} height={16} className={styles.radius6px} />
          </div>
          <Skeleton width={136} height={84} borderRadius={8} />
        </div>
        <div className={styles.consultSkeleton}>
          <div>
            <Skeleton width={444} height={16} style={{marginBottom: '10px'}} className={styles.radius6px} />
            <Skeleton width={444} height={16} style={{marginBottom: '2px'}} className={styles.radius6px} />
            <Skeleton width={300} height={16} className={styles.radius6px} />
          </div>
          <Skeleton width={136} height={84} borderRadius={8} />
        </div>
      </div>
      
    )
  }

  return <></>
  
};

export default SkeletonFeedContent;
